// Pure helpers shared by the section/group views and the GridFilterBar.
// Lives in utils so it can be reused without pulling in any React.

/**
 * Filters a list of stickers by a mode against the user's state.
 * mode ∈ { 'all' | 'missing' | 'duplicates' | 'collected' }
 */
export function applyGridFilter(stickers, mode, state) {
  if (mode === 'missing')    return stickers.filter(s => !state.collected?.[s.number]);
  if (mode === 'duplicates') return stickers.filter(s => (state.duplicates?.[s.number] || 0) > 0);
  if (mode === 'collected')  return stickers.filter(s => !!state.collected?.[s.number]);
  return stickers;
}

/**
 * Computes counts for each filter mode against a list of stickers.
 * Used by the filter bar pills to show live counts.
 */
export function computeGridCounts(stickers, state) {
  let missing = 0, duplicates = 0, collected = 0;
  stickers.forEach(s => {
    if (state.collected?.[s.number]) collected++;
    else missing++;
    if ((state.duplicates?.[s.number] || 0) > 0) duplicates++;
  });
  return { all: stickers.length, missing, duplicates, collected };
}
